export default "__VITE_ASSET__726a7475__"